module.exports = __webpack_public_path__ + "img/logo.980d642d.png";